<div class="snapshot-list-item">
  <div class="card img-holder">
    <div class="card-img-overlay-color"></div>
    @if (snapshot.images | imageForRole:'thumbnail':true; as cover) {
      <img class="card-img"
        [src]="cover | imageUrl:imageTransformations"
        [alt]="cover.alt_text">
    }
    <div class="card-img-overlay">
      @if (isDateWithinXDays(snapshot.date,14)) {
        <div class="status-holder" style="--status-color: var(--bs-danger);"
          >
          @if (isDateWithinXDays(snapshot.date,7)) {
            <div class="status"
              [ngClass]="{bgWarning: isDateWithinXDays(snapshot.date,14),bgDanger: isDateWithinXDays(snapshot.date,7)}"
              >
              <i class="fa-solid fa-clock icon"></i>
              <span *transloco="let t">{{t('common.expiring')}}</span>&nbsp;{{ snapshot.date | date : 'MMMM d' }}
            </div>
          }
        </div>
      }

      <div class="d-flex flex-row align-items-end justify-content-between w-100">

        <div class="d-flex flex-column-reverse flex-lg-column align-items-start gap-2 w-100">
          <div
            class="survey-holder d-none flex-row align-items-center justify-content-start align-self-start flex-wrap gap-2">
            @for (survey of snapshot.surveys; track survey) {
              <span class="survey-item">
                @if (survey.icon?.identifier_1) {
                  <span class="icon"><i class="fa-solid"
                  [ngClass]="survey.icon.identifier_1"></i></span>
                }
                @if (!survey.icon?.identifier_1) {
                  <span><i class="fa-solid fa-check"></i></span>
                }
                {{survey.name}}
              </span>
            }
          </div>

          <div class="d-flex flex-column flex-lg-row align-items-start gap-2">
            <div class="date-status d-flex flex-row gap-2">
              <div class="date">
                <p class="year">{{ snapshot.date | date:'yyyy' }}</p>
                <p class="month-day">
                  <span class="month">
                    {{ snapshot.date | date:'MMM' }}
                  </span>
                </p>
              </div>
              <!-- <div class="status-holder">
              <div class="status" style="--status-color: var(--bs-danger);">
                <div class="content">
                  <i class="fa-solid fa-clock icon"></i>
                  Expiring in 7 days
                </div>
              </div>
            </div> -->
          </div>
          <div class="content d-flex flex-column">
            <h3 class="title">
              <span class="mr-2">
                {{snapshot.title ?? snapshot.label}}
              </span>
              <span class="icons-holder gap-2">
                @for (culture of snapshot.cultures; track culture) {
                  <span class="icons-holder tooltip-custom">
                    <img [src]="'https://cultureconnector.com/assets/images/flags/'+culture.iso+'.png'"
                      [alt]="culture.name">
                    <p class="tooltiptext-custom-top">{{culture.name}}</p>
                  </span>
                }
              </span>
            </h3>
            <p>{{snapshot.description ?? snapshot.info}}</p>
          </div>

        </div>

      </div>

      <button class="btn btn-light mt-2 mt-md-0 w-auto w-md-100 d-none d-lg-block"
        *transloco="let t">
        @if (snapshot.current_accepted) {
          <span><i class="fa-solid fa-arrow-rotate-right fa-spin mr-1"></i></span>
        }
        {{snapshot.current_accepted ? t('common.continue') : t('common.open')}}
      </button>
    </div>
  </div>
</div>
</div>